/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OtherSystemCategory = {
    OtherMedia: 'OtherMedia',
    ContentAndProduction: 'ContentAndProduction',
    AgencyServices: 'AgencyServices',
    ToolsAndLicenses: 'ToolsAndLicenses',
    OfflineEventsAndPromotions: 'OfflineEventsAndPromotions',
    Other: 'Other',
    InternalShipping: 'InternalShipping',
    PackagingVariable: 'PackagingVariable',
    PackagingFixed: 'PackagingFixed'
} as const;
export type OtherSystemCategory = typeof OtherSystemCategory[keyof typeof OtherSystemCategory];


export function instanceOfOtherSystemCategory(value: any): boolean {
    for (const key in OtherSystemCategory) {
        if (Object.prototype.hasOwnProperty.call(OtherSystemCategory, key)) {
            if (OtherSystemCategory[key as keyof typeof OtherSystemCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OtherSystemCategoryFromJSON(json: any): OtherSystemCategory {
    return OtherSystemCategoryFromJSONTyped(json, false);
}

export function OtherSystemCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemCategory {
    return json as OtherSystemCategory;
}

export function OtherSystemCategoryToJSON(value?: OtherSystemCategory | null): any {
    return value as any;
}

export function OtherSystemCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): OtherSystemCategory {
    return value as OtherSystemCategory;
}

